var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "navButton is_initing", attrs: { id: "navButton" } },
      [
        _c("div", { staticClass: "navButton-icon icon-" }),
        _vm._v(" "),
        _c("div", { staticClass: "J_hamburger u_hamburger icon-" }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }